/* @ngInject */
const myCommandeForm = (
  $$autocomplete,
  $$commande,
  toaster,
  labels
) => {
  return {
    restrict: 'E',
    scope: {
      myCommande: '=',
      enableValidator: '=?',
    },
    template: require('./myCommandeForm.html'),

    /* @ngInject */
    controller: (
      $scope
    ) => {
      $scope.fieldsOptions = $$commande.metadata.fields
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: async (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myCommandeForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/commande/directives/forms/myCommandeForm.js